import { saveStateToStorage, hasStateChanged } from '../utils/statePersistence';

// Middleware to automatically persist state changes
export const persistenceMiddleware = (store) => (next) => (action) => {
  const prevState = store.getState();
  const result = next(action);
  const nextState = store.getState();

  if (hasStateChanged(nextState.globalState, prevState.globalState)) {
    if (!store.debouncedSave) {
      store.debouncedSave = createDebouncedSave();
    }
    store.debouncedSave(nextState.globalState);
  }

  return result;
};

// Debounced save function
const createDebouncedSave = (delay = 1000) => {
  let timeoutId;
  
  return (state) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      saveStateToStorage(state);
    }, delay);
  };
};

// Initialize store with persisted state
// No explicit initializer; store preloads state via preloadedState in store.js
